module.exports = __webpack_public_path__ + "img/security.2de29013.svg";